<template>
    <div class="animated fadeIn">
        <b-row v-if="model !== undefined">
            <b-col cols="12" xl="12">
                <Base :widget="model" />
            </b-col>
            <b-col cols="12" xl="12">
                <transition name="slide">
                    <b-card>
                        <b-form @submit="save">

                            <InputField name="name" :label="this.$t('title')" v-model="model.title" @error="fieldError"
                                :rules="{ required: true, length: { min: 2 } }" />

                            <InputField name="description" :label="this.$t('description')" v-model="model.description"
                                @error="fieldError" :rules="{ length: { min: 5 } }" />

                            <SelectField name="type" :label="this.$t('type')" v-model="model.type" @error="fieldError"
                                :items="['TextBox', 'Default', 'Standard', 'StandardFullIcon']"
                                :rules="{ required: true }" />

                            <SelectField name="component" :label="this.$t('component')" v-model="model.component"
                                @error="fieldError" :items="componentList" :rules="{ required: model.type != 'TextBox' }"
                                v-if="model.type != 'TextBox'" />

                            <SelectField name="variant" :label="this.$t('variant')" v-model="model.variant"
                                @error="fieldError" :items="variants" :rules="{ required: false }" />


                            <b-form-group :label="this.$t('formatter')" label-for="formatter" :label-cols="2"
                                :description="model.type != 'TextBox' ? '' : 'Formatter can\'t be set for TextBox widget type'"
                                :horizontal="false">
                                <div class="form-actions" v-if="model.type != 'TextBox'">
                                    <b-button variant="primary" @click="formatterModal.show = true">{{ $t('openEditor')
                                        }}</b-button>
                                </div>
                                <main-dialog size="lg" title="Formatter editor" v-model="formatterModal.show">
                                    <InputField type="number" name="limit" :label="this.$t('limit')"
                                        v-model.number="model.formatter.limit" @error="fieldError"
                                        :description="this.$t('limitOfModels')" :rules="{ required: true }" />

                                    <InputField type="text" name="filter" :label="this.$t('filter')"
                                        v-model="model.formatter.filter" @error="fieldError"
                                        :description="this.$t('searchField')" :rules="{ required: false }" />

                                    <b-form-group :label="this.$t('filterOn')" :label-cols="2" :horizontal="false"
                                        :description="this.$t('filterModels')">
                                        <b-form-checkbox-group id="filter-on-fields" v-model="model.formatter.filterOn"
                                            :options="this.filterOnFields" name="filterOn"></b-form-checkbox-group>
                                    </b-form-group>

                                    <b-form-group :label="this.$t('disabled')" :label-cols="2" :horizontal="false"
                                        :description="this.$t('returnDisabled')">
                                        <c-switch class="mx-1" color="success" variant="pill"
                                            v-model="model.formatter.disabled" />
                                    </b-form-group>

                                    <CodeEditor v-model="model.formatter.code"
                                        editor_description="returned value will be displayed in widget"
                                        :label="this.$t('expression')" :label-cols="2" :horizontal="true" :libs="libs"
                                        :vars="vars" />
                                </main-dialog>
                            </b-form-group>
                            <b-form-group :label="this.$t('progressBar')" :label-cols="2" :horizontal="false"
                                :description="model.type == 'Default' ? '' : 'Progress bar can be modified just when widget type is \'Default\''">
                                <div class="form-actions" v-if="model.type == 'Default'">
                                    <b-button variant="primary" @click="progressBarModal.show = true">{{
                                        $t('openEditor') }}</b-button>
                                </div>
                                <main-dialog size="md" title="Progress Bar editor" v-model="progressBarModal.show">
                                    <b-form-group :label="this.$t('display')" :label-cols="2" :horizontal="false">
                                        <c-switch class="mx-1" color="success" variant="pill"
                                            v-model="model.progressBar.bar" />
                                    </b-form-group>

                                    <SelectField name="variant" :label="this.$t('variant')" v-model="model.icon.variant"
                                        @error="fieldError" :items="variants" :rules="{ required: false }" />

                                    <CodeEditor v-model="model.progressBar.formatter"
                                        editor_description="calculations are counted towards progress bar"
                                        :label="this.$t('expression')" :label-cols="2" :horizontal="true" :libs="libs"
                                        :vars="vars" />
                                </main-dialog>

                            </b-form-group>
                            <b-form-group :label="this.$t('icon')" :label-cols="2" :horizontal="false"
                                :description="model.type != 'TextBox' ? '' : 'Icon can\'t be set for TextBox widget type'">
                                <div class="form-actions" v-if="model.type != 'TextBox'">
                                    <b-button variant="primary" @click="iconModal.show = true">{{ $t('openEditor')
                                        }}</b-button>
                                </div>
                                <main-dialog size="md" title="Icon editor" v-model="iconModal.show">

                                    <SelectField name="position" :label="this.$t('position')" v-model="model.icon.type"
                                        @error="fieldError" :items="['left', 'right']" :rules="{ required: false }"
                                        v-if="model.type == 'Default'" />

                                    <Appearance v-model="model.icon.value" :description="this.$t('iconWidget')" />

                                    <SelectField name="icon_variant" :label="this.$t('variant')"
                                        v-model="model.icon.variant" @error="fieldError" :items="variants"
                                        :rules="{ required: (model.type == 'StandardFullIcon') }"
                                        v-if="model.type != 'Default'" />
                                </main-dialog>

                            </b-form-group>
                            <b-form-group :label="this.$t('size')" label-for="size" :label-cols="2" :horizontal="false">
                                <div class="form-actions">
                                    <b-button variant="primary" @click="sizeModal.show = true"></b-button>
                                </div>
                                <main-dialog size="md" title="Size editor" v-model="sizeModal.show">

                                    <InputField type="number" name="sm" :label="this.$t('mobile')"
                                        v-model.number="model.size.sm" @error="fieldError"
                                        :rules="{ length: { min: 1, max: 12 } }" />

                                    <InputField type="number" name="md" :label="this.$t('tablet')"
                                        v-model.number="model.size.md" @error="fieldError"
                                        :rules="{ length: { min: 1, max: 12 } }" />

                                    <InputField type="number" name="lg" :label="this.$t('desktop')"
                                        v-model.number="model.size.lg" @error="fieldError"
                                        :rules="{ length: { min: 1, max: 12 } }" />
                                </main-dialog>
                            </b-form-group>
                            <b-form-group :label="this.$t('active')" :label-cols="2" :horizontal="false">
                                <c-switch class="mx-1" color="success" variant="pill" v-model="model.is_active" />
                            </b-form-group>

                            <div class="form-actions float-right">
                                <b-button type="submit" variant="success">{{ $t('saveChanges') }}</b-button>
                                <b-button variant="danger" @click="remove">{{ $t('delete') }}</b-button>
                            </div>
                        </b-form>
                    </b-card>
                </transition>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { deepCopyObject } from '../../shared/utils'
import { Switch as cSwitch } from '@coreui/vue'
import Appearance from '../../components/base/Settings/Appearance'

import Code from "@/components/form/Editor/Code"

import Input from "@/components/form/Input"
import Select from "@/components/form/Select"

import Base from "../../components/widgets/Base"

export default {
    name: "Edit",
    components: {
        InputField: Input,
        SelectField: Select,
        CodeEditor: Code,
        cSwitch,
        Appearance,
        Base
    },
    data: function () {
        return {
            filterOnFields: [],
            errors: [],
            progressBarModal: {
                show: false,
                formatterModal: {
                    show: false,
                    options: {
                        tabSize: 4,
                        lineNumbers: true,
                        line: true,
                        autoRefresh: true,
                        foldGutter: true,
                        styleSelectedText: true,
                        mode: 'text/javascript',
                        matchBrackets: true,
                        showCursorWhenSelecting: true
                    }
                }
            },

            iconModal: {
                show: false
            },

            formatterModal: {
                show: false
            },

            sizeModal: {
                show: false
            },

            variants: [
                'primary',
                'secondary',
                'info',
                'danger',
                'warning',
                'success',
                'light',
                'dark'
            ],

            libs: [
                {
                    name: "Lodash",
                    varName: "_",
                    docs: "https://lodash.com/"
                }
            ]
        }
    },
    watch: {
        model: {
            handler(val) {
                if (val === undefined) {
                    return
                }
                // match to remove error field
                if (val.type !== 'StandardFullIcon') {
                    this.errors = this.errors.filter(e => {
                        return e.field != 'icon_variant';
                    })
                }

                if (val.type == 'TextBox') {
                    this.errors = this.errors.filter(e => {
                        return e.field != 'component';
                    })
                }

                if (val.component != "") {
                    let settings = this.$store.getters.componentSettings(val.component)
                    this.filterOnFields = settings.settings.fields.map(f => {
                        return f.key;
                    })
                }
            },
            deep: true
        }
    },
    computed: {
        model() {
            return this.$store.getters.widget(this.$route.params.id)
        },

        componentList() {
            let menu = deepCopyObject(this.$store.getters.componentsMenu)
            let filtered = menu.filter(m => {
                return m.is_active
            })

            filtered.map(m => {
                m.text = m.name
                m.value = m.uuid
            })

        return filtered
        },

        vars() {
            return [
                {
                    name: "models",
                    usage: this.modelFields()
                }
            ]
        }
    },

    methods: {
        save(e) {
            e.preventDefault()

            if (this.checkForErrors()) {
                this.$mainDialog.msgBoxOk(this.$t('fieldsNotValid'))

                return
            }

            this.$http.post("/v1/system/widget/update/" + this.$route.params.id, this.model).then(resp => {

                this.$bvToast.toast("Widget updated", {
                    variant: 'success',
                    title: "Success"
                })

            }).catch(error => {
                if (error.response.status == 500) {
                    this.$serverErrorModal(error)
                    return
                }

                this.$mainDialog.msgBoxOk(error.response.data.message)
            })
        },

        remove() {
            this.$mainDialog.msgBoxConfirm(`${this.$t('areYouSure')}?`).then((resp) => {
                if (resp) {
                    this.$http.delete("/v1/system/widget/" + this.$route.params.id, this.model).then(resp => {
                        this.$store.commit("DELETE_WIDGET", this.$route.params.id)
                        this.$router.back()

                    }).catch(error => {
                        if (error.response.status == 500) {
                            this.$serverErrorModal(error)
                            return
                        }

                        this.$mainDialog.msgBoxOk(error.response.data.message)
                    })
                }
            })

        },

        fieldError(error) {
            let found = this.errors.find((i, e) => {
                return i.field == error.field
            })

            if (found === undefined) {
                this.errors.push(error)
            } else {
                this.errors.map(e => {
                    if (found.field == e.field)
                        e.error = error.error
                })
            }
        },

        checkForErrors() {
            return this.errors.find((i, e) => {
                return i.error
            })
        },

        modelFields() {
            let component = this.$store.getters.componentSettings(this.model.component)

            if (component !== undefined) {
                let fields = component.settings.fields

                let formated = {}

                fields.forEach(f => {
                    formated[f.key] = null

                    if (f.module == "input" || f.module == "textarea") {
                        formated[f.key] = ""

                        if (f.type == "number") {
                            formated[f.key] = 0
                        }
                    }
                })

                return '[' + JSON.stringify(formated) + ']'
            }

            return ''

        }
    },
    mounted() {
        if (this.model !== undefined) {
            let settings = this.$store.getters.componentSettings(this.model.component)
            if (settings !== undefined) {
                this.filterOnFields = settings.settings.fields.map(f => {
                    return f.key;
                })
            }
        }

        // recalculate model fields so it can be used in editor to display available fields in code editor
        this.modelFields();

        // ── Kortex AI tools ──────────────────────────────────────
        if (!window.kortex) return

        window.kortex.showHelper()
        window.kortex.registerContext(
            'Widget Editor',
            'BEFORE YOU DO ANYTHING ELSE: first search the internal knowledge base for relevant topics. ' +
            'The user is editing a dashboard widget. You can read the widget configuration, modify the title, ' +
            'read and update the formatter code (JavaScript expression that returns a value to display), ' +
            'and save the widget. Use get_widget_info to see the current state first.',
            'fa-th-large'
        )

        var self = this

        window.kortex.registerTool(
            {
                type: 'function',
                function: {
                    name: 'get_widget_info',
                    description: 'Returns the current widget configuration: title, type, variant, component, and formatter settings.',
                    parameters: { type: 'object', properties: {} }
                }
            },
            function () {
                var m = self.model
                if (!m) return { error: 'Widget not loaded' }
                return {
                    uuid: m.uuid,
                    title: m.title,
                    description: m.description || '',
                    type: m.type,
                    variant: m.variant || null,
                    component: m.component || null,
                    formatter: m.formatter ? {
                        code: m.formatter.code || '',
                        filter: m.formatter.filter || '',
                        limit: m.formatter.limit,
                        filter_on: m.formatter.filterOn || [],
                        disabled: m.formatter.disabled || false
                    } : null,
                    progress_bar: m.progressBar ? {
                        enabled: m.progressBar.bar || false,
                        formatter: m.progressBar.formatter || ''
                    } : null
                }
            }
        )

        window.kortex.registerTool(
            {
                type: 'function',
                function: {
                    name: 'set_widget_title',
                    description: 'Updates the widget title. User must save to persist.',
                    parameters: {
                        type: 'object',
                        required: ['title'],
                        properties: {
                            title: { type: 'string', description: 'The new widget title.' }
                        }
                    }
                }
            },
            function (args) {
                var title = (args.title || '').trim()
                if (!title) return { error: 'Title cannot be empty.' }
                self.$set(self.model, 'title', title)
                return { title: title, saved: false, note: 'Title updated. User must click Save to persist.' }
            }
        )

        window.kortex.registerTool(
            {
                type: 'function',
                function: {
                    name: 'get_widget_formatter_code',
                    description: 'Returns the JavaScript formatter code used to compute the widget display value.',
                    parameters: { type: 'object', properties: {} }
                }
            },
            function () {
                var m = self.model
                if (!m) return { error: 'Widget not loaded' }
                var code = m.formatter && m.formatter.code ? m.formatter.code : ''
                return { code: code, type: m.type === 'TextBox' ? 'not_applicable' : 'javascript' }
            }
        )

        window.kortex.registerTool(
            {
                type: 'function',
                function: {
                    name: 'set_widget_formatter_code',
                    description: 'Replaces the JavaScript formatter code. User must save to persist.',
                    parameters: {
                        type: 'object',
                        required: ['code'],
                        properties: {
                            code: { type: 'string', description: 'The new JavaScript formatter code.' }
                        }
                    }
                }
            },
            function (args) {
                var m = self.model
                if (!m) return { error: 'Widget not loaded' }
                if (m.type === 'TextBox') return { error: 'Formatter cannot be set for TextBox widgets.' }
                if (!m.formatter) self.$set(m, 'formatter', {})
                self.$set(m.formatter, 'code', args.code)
                return { length: args.code.length, saved: false, note: 'Formatter code updated. User must click Save to persist.' }
            }
        )

        window.kortex.registerTool(
            {
                type: 'function',
                function: {
                    name: 'save_widget',
                    description: 'Persists all widget settings to the server.',
                    parameters: { type: 'object', properties: {} }
                }
            },
            function () {
                if (!self.model) return { error: 'Widget not loaded' }
                return self.$http.post('/v1/system/widget/update/' + self.$route.params.id, self.model).then(function () {
                    return { saved: true }
                }).catch(function (err) {
                    return { error: (err.response && err.response.data && err.response.data.message) || 'Save failed' }
                })
            }
        )
    },

    beforeDestroy() {
        if (!window.kortex) return
        window.kortex.unregisterContext()
        window.kortex.hideHelper()
        window.kortex.unregisterTool('get_widget_info')
        window.kortex.unregisterTool('set_widget_title')
        window.kortex.unregisterTool('get_widget_formatter_code')
        window.kortex.unregisterTool('set_widget_formatter_code')
        window.kortex.unregisterTool('save_widget')
    }
}
</script>
